export class ListUsersResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<User>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListUsersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
